export default __webpack_public_path__ + "static/media/barImage.7dbe8210.png";